import $ from "jquery";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof Shopify === 'undefined') {
    Shopify = {};
}
if (!Shopify.formatMoney) {
    Shopify.formatMoney = function (cents, format) {
        var value = '',
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || this.money_format;

        if (typeof cents == 'string') {
            cents = cents.replace('.', '');
        }

        function defaultOption(opt, def) {
            return typeof opt == 'undefined' ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? decimal + parts[1] : '';

            return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    };
}

export default () => {
    (function (giftSlider, $) {
        var $dom = {};
        var arrow = '<svg fill="#000000" viewBox="0 0 129 129"><path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"/></svg>';
        var cacheDom = function cacheDom() {
            $dom.pdpSlider = $('.gift-products');
            $dom.selectGift = $('.productGift');
            $dom.btnAddtoCart = $('.c-addtocart');
        };
        var SlidersInit = function SlidersInit() {
            var pdpSliderOptions = {
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
                infinite: false,
                arrows: true,
                prevArrow: '<span class="slick-arrow slick-prev">' + arrow + '</span>',
                nextArrow: '<span class="slick-arrow slick-next">' + arrow + '</span>'
            };
            $dom.pdpSlider.slick(pdpSliderOptions);
        };

        var defaultSelection = function defaultSelection() {
            $('.productGift').each(function () {
                if ($(this).is(':checked')) {
                    var $this = $(this);
                    var index = $(this).attr('data-index');
                    $('.gift-product-' + index + '-title').html($this.attr('data-product-title'));
                    $('.gift-product-' + index + '-price').html($this.attr('data-product-price'));
                    $('.gift-product-' + index + '-image').attr('src', $this.attr('data-product-img'));
                    $('.gift-product-' + index + '-price').attr('data-price', $this.attr('data-price'));
                    $('.gift-product-id-' + index).val($this.attr('data-product-id'));
                }
            });
        };
        var totalPrice = function totalPrice() {
            var pro1Price = $('.gift-product-1-price').attr('data-price');
            var pro2Price = $('.gift-product-2-price').attr('data-price');
            var pro3Price = $('.gift-product-3-price').attr('data-price');
            if (pro1Price != '' && pro2Price != '' && pro3Price != '') {
                var priceTotal = parseFloat(pro1Price) + parseFloat(pro2Price) + parseFloat(pro3Price);
                $('.orignl_price').html(Shopify.formatMoney(priceTotal, theme.moneyFormat));
                $('.saved_price').html(Shopify.formatMoney(percentage(priceTotal, 14), theme.moneyFormat));
            }
        };

        var percentage = function percentage(listPrice, discount) {
            listPrice = parseFloat(listPrice);
            discount = parseFloat(discount);
            return listPrice - listPrice * discount / 100; // Sale price
        };

        var giftAddToCart = function giftAddToCart() {
            $dom.btnAddtoCart.on('click', function (e) {
                e.preventDefault();
                var randomNumber = Math.floor(Math.random() * (10000 - 100 + 1) + 100);
                $('.product_random').val(randomNumber);
                var $this = $(this);
                if ($('.gift-product-id-1').val() == '' || $('.gift-product-id-2').val() == '' || $('.gift-product-id-3').val() == '') {
                    $('.error-msg').html('Please select Product');
                    setTimeout(function () {
                        $('.error-msg').html('');
                    }, 2000);
                    return false;
                }
                $.ajax({
                    url: '/cart/add.js',
                    type: 'POST',
                    dataType: 'json',
                    data: $this.closest('form').serializeArray(),
                    success: function success(cart) {
                        setTimeout(function () {
                            window.location.href = "/cart";
                        }, 1000);
                    }
                });
            });
        };

        var _selectGiftProduct = function _selectGiftProduct() {
            var count = 3;
            var message = '';
            $dom.selectGift.on('change', function (e) {
                e.preventDefault();
                var $this = $(this);
                var index = $this.attr('data-index');
                if (index == '1') {
                    message = 'Add 2 more Item from Gift Collection to Checkout.';
                    $('.gift-product-1-title').html($this.attr('data-product-title'));
                    $('.gift-product-1-price').html($this.attr('data-product-price'));
                    $('.gift-product-1-image').html("<img  class='my-3 mx-auto' src=" + $this.attr('data-product-img') + "alt=" + $this.attr('data-product-title') + ">");
                    $('.gift-product-1-price').attr('data-price', $this.attr('data-price'));
                    $('.gift-product-id-1').val($this.attr('data-product-id'));
                    $('#custom_title_2').click();
                    if ($('.gift-product-id-2').val() == '') {
                        $('.delete_routine[data-step="2"]').click();
                    }
                    if ($('.gift-product-id-1').val() != '' && $('.gift-product-id-2').val() != '' && $('.gift-product-id-3').val() != '') {
                        $('.price-box').addClass('active');
                    }
                    // alertify.notify(message, 'success', 2);
                }
                if (index == '2') {
                    message = 'Add 1 more Item from Gift Collection to Checkout.';
                    $('.gift-product-2-title').html($this.attr('data-product-title'));
                    $('.gift-product-2-price').html($this.attr('data-product-price'));
                    $('.gift-product-2-price').attr('data-price', $this.attr('data-price'));
                    $('.gift-product-2-image').html("<img  class='my-3 mx-auto' src=" + $this.attr('data-product-img') + "alt=" + $this.attr('data-product-title') + ">");
                    $('#custom_title_3').click();
                    if ($('.gift-product-id-3').val() == '') {
                        $('.delete_routine[data-step="3"]').click();
                    }
                    $('.gift-product-id-2').val($this.attr('data-product-id'));
                    if ($('.gift-product-id-1').val() != '' && $('.gift-product-id-2').val() != '' && $('.gift-product-id-3').val() != '') {
                        $('.price-box').addClass('active');
                    }
                    // alertify.notify(message, 'success', 2);
                }
                if (index == '3') {
                    message = 'You have selected 3 prodcuts. Your order is eligible for checkout.';
                    $('.gift-product-3-title').html($this.attr('data-product-title'));
                    $('.gift-product-3-price').html($this.attr('data-product-price'));
                    $('.gift-product-3-price').attr('data-price', $this.attr('data-price'));
                    $('.gift-product-3-image').html("<img  class='my-3 mx-auto' src=" + $this.attr('data-product-img') + "alt=" + $this.attr('data-product-title') + ">");
                    $('.gift-product-id-3').val($this.attr('data-product-id'));
                    if ($('.gift-product-id-1').val() != '' && $('.gift-product-id-2').val() != '' && $('.gift-product-id-3').val() != '') {
                        $('.price-box').addClass('active');
                    }
                    // alertify.notify(message, 'success', 2);
                }
                totalPrice();
                bodyHeight();
            });
        };

        var bodyHeight = function bodyHeight() {
            var height = $('.gift-product-result').outerHeight();
            $('body').css('padding-bottom', height);
        };

        giftSlider.init = function () {
            cacheDom();
            // SlidersInit();
            // defaultSelection();
            bodyHeight();
            _selectGiftProduct();
            totalPrice();
            giftAddToCart();
        };
    })(window.giftSlider = window.giftSlider || {}, $, undefined);
};